import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const CET_FMT = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit",
});

/** Format a UTC ISO string as CET/CEST local time: "DD.MM.YYYY, HH:MM" */
export function fmtCET(isoStr) {
  if (!isoStr) return "";
  try {
    return CET_FMT.format(new Date(isoStr));
  } catch {
    return isoStr.slice(0, 16);
  }
}

/** Short date only in CET: "DD.MM.YYYY" */
export function fmtCETDate(isoStr) {
  if (!isoStr) return "";
  try {
    return new Intl.DateTimeFormat("de-DE", {
      timeZone: "Europe/Berlin",
      year: "numeric", month: "2-digit", day: "2-digit",
    }).format(new Date(isoStr));
  } catch {
    return isoStr.slice(0, 10);
  }
}
